import React from 'react';
import { SkeletonLista, SkeletonCard } from '../Skeleton';
import EmptyState from './EmptyState';

/**
 * Envelope de carregamento / erro / vazio.
 *
 * O app engolia falhas com `.catch(() => {})` em cerca de trinta pontos: numa
 * queda de rede a tela ficava vazia sem explicar nada, e o usuário concluía que
 * havia perdido os dados. Aqui o erro é visível e oferece nova tentativa.
 */
export default function Estado({
  carregando, erro, vazio, aoTentarNovamente,
  skeleton = 'lista', itens = 3, children, vazioProps,
}) {
  if (carregando) {
    return skeleton === 'card' ? <SkeletonCard linhas={itens} /> : <SkeletonLista itens={itens} />;
  }

  if (erro) {
    return (
      <EmptyState
        compacto
        icone="alerta"
        titulo="Não foi possível carregar"
        descricao={typeof erro === 'string' ? erro : 'Verifique sua conexão e tente novamente.'}
        acao={aoTentarNovamente ? { onClick: aoTentarNovamente, label: 'Tentar novamente' } : undefined}
      />
    );
  }

  if (vazio) return <EmptyState compacto {...(vazioProps || { titulo: 'Nada por aqui ainda' })} />;

  return children;
}
